import { NotificationsRequest } from "services/types/NotificationTypes";

export enum NotificationsActionType {
  ChangedUser = "changed_user",
  ChangedPage = "changed_page",
}

export type NotificationsAction = {
  type: NotificationsActionType;
  request?: NotificationsRequest;
};

export const notificationsReducer = (
  state: NotificationsRequest,
  action: NotificationsAction
): NotificationsRequest => {
  switch (action.type) {
    case NotificationsActionType.ChangedUser:
      return action.request
        ? {
          userId: action.request.userId,
          userToken: action.request.userToken,
          pageSize: action.request.pageSize,
          page: 1,
        }
        : state;
    case NotificationsActionType.ChangedPage:
      return {
        ...state,
        page: state.page + 1,
      };
    default:
      return state;
  }
};